
import {GetServerSideProps} from 'next'
import {useEffect} from 'react'
import getUaParam from '@/utils/getUaParam'
import {SUCCESS_CODE} from '@/constants'
import {showUpgradeApp} from '@/plugins/bridge'
import {CustomErrorPage} from '@/components/CustomError'
import useViewReport from '@/hooks/useViewReport'
import {useUaParam} from './_app'

interface IUpgradeProps {
  hiddenTitleBar?: boolean;
}

const Upgrade = (props: IUpgradeProps) => {
    const {bookId, equityNumber} = useUaParam()
    useViewReport('升级app页面曝光')
    // useEffect(() => {
    //     showUpgradeApp();
    // }, []);

    return (
        <CustomErrorPage
            type='empty'
            hiddenTitleBar={props.hiddenTitleBar}
            noError
            description='当前版本暂不支持使用该功能, 请更新app后使用'
            showBtn
            btnText='立即更新'
            onBtnClick={showUpgradeApp}
            reason='需要升级app'
            otherInfo={{}}
        />
    )
}

export const getServerSideProps: GetServerSideProps = async ({
    req,
    resolvedUrl,
    query,
}) => {
    const {equityNumber, bookId} = getUaParam(req.url, req.headers['user-agent'])

    return {
        props: {code: SUCCESS_CODE},
    }
}

export default Upgrade
